import * as d3 from "d3";
const chartDiv = document.getElementById("chart");
export const margin = { top: 20, right: 20, bottom: 40, left: 55 };
export let width = +chartDiv.clientWidth - margin.left - margin.right;
export let height = +chartDiv.clientHeight - margin.top - margin.bottom;

export function initD3Chart() {
  let svg = d3.select(chartDiv).append("svg");
  svg.append("g").attr("class", "chart");
}

export function scaleD3Chart() {
  let svg = d3.select(chartDiv).select("svg");

  // update the width and height when window resized
  width = +chartDiv.clientWidth - margin.left - margin.right;
  height = +chartDiv.clientHeight - margin.top - margin.bottom;

  //scale the svg
  svg
    .attr("width", width + margin.left + margin.right)
    .attr("height", height + margin.top + margin.bottom);

  // scale the chart area
  svg
    .select("g.chart")
    .attr("width", width + margin.right)
    .attr("height", height + margin.bottom)
    .attr("transform", "translate(" + margin.left + "," + margin.top + ")");
}
